/**
 * 31.08.12 Created
 * @author Stanislav Yaranov <for_stas@mail.ru>
 * @version 1.0
 */

/**
 * @param datetime {String} What to parse
 * @param format {String} How to parse
 *
 * YYYY - year four digits
 * MM - month two digits
 * DD - day two digits
 * HH24 - hours two digits
 * MI - minutes two digits
 * SS - seconds two digits
 * MS - milliseconds more than one digit
 * TZ - timezone plus or minus and one or more digits
 */
Date.fromFormat = function (datetime, format) {
	var date = new Date();

	try {
		datetime = datetime.toString();
	} catch (e) {
		datetime = "";
	}

	var patterns = {
		"YYYY": {
			"pattern": "\\d{4}",
			"exec": function (date, value) {
				date.setFullYear(value);
			}
		},
		"MM": {
			"pattern": "\\d{2}",
			"exec": function (date, value) {
				date.setMonth(value - 1);
			}
		},
		"DD": {
			"pattern": "\\d{2}",
			"exec": function (date, value) {
				date.setDate(value);
			}
		},
		"HH24": {
			"pattern": "\\d{2}",
			"exec": function (date, value) {
				date.setHours(value);
			}
		},
		"MI": {
			"pattern": "\\d{2}",
			"exec": function (date, value) {
				date.setMinutes(value);
			}
		},
		"SS": {
			"pattern": "\\d{2}",
			"exec": function (date, value) {
				date.setSeconds(value);
			}
		},
		"MS": {
			"pattern": "\\d+",
			"exec": function (date, value) {
				date.setMilliseconds(value.substr(0, 3));
			}
		},
		"TZ": {
			"pattern": "[+-]\\d+",
			"exec": function () {
			}
		}
	};

	for (var currentItem in patterns) {
		if (patterns.hasOwnProperty(currentItem)) {
			var pattern = format;
			var hasPattern = false;

			pattern = pattern.replace(/([.+])/g, "\\$1");

			for (var item in patterns) {
				if (patterns.hasOwnProperty(item)) {
					if (item == currentItem) {
						pattern = pattern.replace(item, "(" + patterns[item]["pattern"] + ")");
						hasPattern = true;
					} else {
						pattern = pattern.replace(item, patterns[item]["pattern"]);
					}
				}
			}

			var matches = datetime.match(new RegExp("^" + pattern + "$"));

			if (matches && matches.length > 1) {
				patterns[currentItem].exec(date, matches[1]);
			}
		}
	}

	return date;
};

Date.fromPG = function (datetime) {
	return this.fromFormat(datetime, "YYYY-MM-DD HH24:MI:SS.MSTZ");
};

Date.fromDate = function (datetime) {
	return this.fromFormat(datetime, "YYYY-MM-DD");
};

Date.fromTZ = function (datetime) {
	var date = this.fromFormat(datetime, "YYYY-MM-DD HH24:MI:SSTZ");
	date.setMilliseconds(0);

	return date;
};

Date.fromTime = function (datetime) {
	return this.fromFormat(datetime, "HH24:MI:SS");
};

Date.fromTimeTZ = function (datetime) {
	return this.fromFormat(datetime, "HH24:MI:SSTZ");
};

Date.fromDateTime = function (datetime) {
	return this.fromFormat(datetime, "YYYY-MM-DD HH24:MI:SS");
};

Date.diff = function (fromDate, toDate) {
	var result = {};

	if (!toDate) {
		toDate = new Date();
	}

	if (fromDate > toDate) {
		var tmp = fromDate;

		fromDate = toDate;
		toDate = tmp;
	}

	var periods = [
		{ name: "milliseconds", method: "getMilliseconds", size: 1000 },
		{ name: "seconds", method: "getSeconds", size: 60 },
		{ name: "minutes", method: "getMinutes", size: 60 },
		{ name: "hours", method: "getHours", size: 24 },
		{ name: "days", method: "getDate", size: new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate() },
		{ name: "months", method: "getMonth", size: 12 },
		{ name: "years", method: "getFullYear", size: 0 }
	];

	for (var i = 0; i < periods.length; i++) {
		var period = periods[i];

		result[period.name] = toDate[period.method]() - fromDate[period.method]() + ~~period.correction;

		if (result[period.name] < 0) {
			result[period.name] += period.size;
			periods[i + 1].correction = -1;
		}
	}

	return result;
};